import type { FC } from 'react';

import { CardItem } from 'src/app/components/Elements/Card';
import { CardRowText } from 'src/app/components/Elements/Card/CardRowText';
import { formatPrice } from 'src/app/utils';

interface OrderPriceBreakdownProps {
  tip: number;
  subtotal: number;
  tax: number;
  noDivider?: boolean;
  showPrice?: boolean;
}

export const OrderPriceBreakdown: FC<OrderPriceBreakdownProps> = ({
  tip,
  subtotal,
  tax,
  showPrice = true,
  noDivider = true,
}) => {
  return (
    <CardItem noDivider={noDivider}>
      <CardRowText
        leftText={'Item Subtotal'}
        rightText={showPrice ? formatPrice(subtotal) : '—'}
        leftTextVariant={'overline'}
        rightTextVariant={'body'}
      />

      {tip !== null ? (
        <CardRowText
          leftText={'Tip'}
          rightText={showPrice ? formatPrice(tip) : '—'}
          leftTextVariant={'overline'}
          rightTextVariant={'body'}
        />
      ) : null}

      {tax ? (
        <CardRowText
          leftText={'Tax'}
          rightText={showPrice ? formatPrice(tax) : '—'}
          leftTextVariant={'overline'}
          rightTextVariant={'body'}
        />
      ) : null}
    </CardItem>
  );
};
